'use strict';

var passiveSupported = false;

if (typeof window !== 'undefined') {
  try {
    var options = Object.defineProperty({}, 'passive', {
      get: function get() {
        passiveSupported = true;
      }
    });

    window.addEventListener('test', null, options);
  } catch (err) {}
}

module.exports = passiveSupported;



//////////////////
// WEBPACK FOOTER
// ./~/subscribe-ui-event/dist/lib/supportPassiveEvent.js
// module id = 2549
// module chunks = 0